export default {
  state: {
    processes: {},
  },
  getters: {
    processInProgress: state => process =>
      state.processes[process] != undefined
        ? state.processes[process].status
        : false,
  },
  actions: {
    startProcess({ commit, dispatch }, { process, progress }) {
      if (progress) {
        //show progress bar
        dispatch('showProgressBar')
      }
      commit('START_PROCESS', { process, progress })
    },
    stopProcess({ state, commit, dispatch }, process) {
      if (state.processes[process]) {
        const progress = state.processes[process].progress
        if (progress) {
          //hide progressbar
          dispatch('hideProgressBar')
        }
        commit('STOP_PROCESS', process)
      }
    },
  },
  mutations: {
    START_PROCESS: (state, { process, progress }) => {
      let stateProcess = { ...state.processes }
      stateProcess[process] = {
        status: true,
        progress,
      }
      state.processes = stateProcess
    },
    STOP_PROCESS: (state, process) => {
      let stateProcess = { ...state.processes }
      stateProcess[process].status = false
      stateProcess[process].progress = false

      state.processes = stateProcess
    },
  },
}
